//DaysettingUtils.js
//Shared utilities for daysettings
export default function modes (custom_modes) {
	let customs = custom_modes || [];
	var standard = [
		/*
		message - Upper display message
		speed - Digits (lower display)
		flash - flashing displays (flashOnTime, flashOffTime, ...)
		strobe - GPIO for (typically strobe)
		beacon - ? not sure it came from VSO
		

		Positions in arrays above:
		1. No vehicle detected
		2. Vehicle exceeding threshold
		3. Vehicle exceeding max
		4. Vehicle exceeding Max2 
		5. GPIO input trigger (mini push button on SafeXing)

		More details at: https://docs.google.com/spreadsheets/d/18yraEpYCDohCjWgHfugCkOGAEKPh3SqMljvvqtqkVHA/edit#gid=1065576328
		*/
		{	//0
			message : [1, 2, 0, 4],
			speed : [1, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //1
			message : [1, 2, 3, 4],
			speed : [1, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //2
			message : [1, 2, 3, 4],
			speed : [1, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //3
			message : [0, 3, 3, 4],
			speed : [0, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //4
			message : [0, 2, 3, 4],
			speed : [0, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //5
			message : [0, 2, 3, 0],
			speed : [0, 1, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //6
			message : [0, 2, 3, 4],
			speed : [0, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//7
			message : [0, 2, 2, 4],
			speed : [0, 2, 2, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, { //8
			message : [0, 2, 3, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//9
			message : [0, 2, 3, 4],
			speed : [0, 1, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//10
			message : [0, 2, 2, 4],
			speed : [0, 1, 2, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
			
		}, {//11
			message : [0, 5, 6, 0, 7],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//12 - configurable
			special : 1,
			message : [0, 2, 2, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//13 - configurable
			special : 1,
			message : [0, 2, 2, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//14 - configurable
			special : 1,
			message : [0, 2, 2, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//15 - configurable
			special : 1,
			message : [0, 2, 2, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//16 - configurable
			special : 1,
			message : [0, 2, 2, 4],
			speed : [0, 2, 0, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//17
			message : [0, 4, 3, 4],
			speed : [0, 1, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//18
			message : [1, 3, 3, 4],
			speed : [1, 1, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		
		}, {//19
			message : [0, 4, 4, 3],
			speed : [0, 1, 1, 1],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
			
		}, {//20
			message : [4, 2, 3, 1],
			speed : [1, 2, 1, 0],
			flash : [0, 0, 1, 0],
			strobe : [0, 0, 1, 0]
		}, {//21
			message : [0, 0, 0, 0, 6],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//22
			message : [0, 0, 0, 0, 7],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//23
			special : 1,
			message : [0, 0, 0, 0, 6],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//24
			message : [0, 0, 6, 6, 7],
			speed : [0, 2, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//25
			message : [0, 6, 6, 0, 7],
			speed : [0, 2, 1, 0, 0],
			flash : [0, 1, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//26
			message : [0, 6, 6, 0, 7],
			speed : [0, 2, 1, 0, 0],
			flash : [0, 1, 1, 0, 0],
			strobe : [0, 0, 0, 1, 0]
		}, {//27
			message : [0, 0, 6, 0, 7],
			speed : [0, 2, 2, 0, 0],
			flash : [0, 0, 1, 1, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//28
			message : [0, 0, 6, 6, 7],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 1, 0],
			strobe : [0, 0, 0, 1, 0]
		}, {//29
			special : 1,
			message : [0, 0, 0, 0, 0],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 0, 0, 0],
			strobe : [0, 0, 0, 0, 0]
		}, {//30
			message : [0, 8, 3, 0, 0],
			speed : [0, 3, 1, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//31
			special: 1,
			message : [0, 0, 0, 0, 6],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//32
			special: 1,
			message : [0, 0, 0, 0, 6],
			speed : [0, 0, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//33
			message : [0, 0, 6, 6, 0],
			speed : [2, 2, 0, 0, 0],
			flash : [0, 1, 1, 1, 0],
			strobe : [0, 0, 0, 1, 0]
		}, {//34
			message : [0, 6, 6, 6, 0],
			speed : [2, 2, 0, 0, 0],
			flash : [0, 1, 1, 1, 0],
			strobe : [0, 0, 0, 1, 0]
		
		}, {//35
			message : [0, 8, 13, 0, 0],
			speed : [0, 2, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//36
			message : [0, 0, 13, 0, 0],
			speed : [0, 2, 0, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//37
			message : [0, 0, 13, 13, 0],
			speed : [0, 2, 1, 0, 0],
			flash : [0, 0, 0, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//38
			message : [0, 2, 11, 0, 0],
			speed : [0, 2, 5, 0, 0],
			flash : [0, 1, 1, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//39
			message : [0, 2, 11, 0, 0],
			speed : [0, 2, 5, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//40
			message : [0, 2, 11, 0, 0],
			speed : [0, 2, 5, 0, 0],
			flash : [0, 0, 0, 0, 0],
			strobe : [0, 0, 1, 1, 0]
		}, {//41
			message : [1, 2, 3, 4, 0],
			speed : [1, 2, 1, 0, 0],
			flash : [0, 0, 1, 0, 0],
			strobe : [0, 0, 1, 0, 0]
		}, {//42
			message : [0, 2, 3, 12, 6],
			speed : [0, 2, 1, 2, 0],
			flash : [0, 0, 1, 1, 0],
			strobe : [0, 0, 1, 1, 0]
		}
	];
	return standard.map((m, i) => {
		m.id=i;
		return m;
	}).concat(customs);
}